const Embed = () => {

    const embedElements = document.querySelectorAll('.embed-js');

    embedElements.forEach(function(element) {
        // Dodajemy nasłuchiwanie na kliknięcie w element .embed-js
        element.addEventListener('click', function() {
            // Pobieramy URL filmu z data atrybutu
            const videoUrl = element.getAttribute('data-video-url');
            
            // Sprawdzamy, czy URL jest prawidłowy
            try {
                new URL(videoUrl);
            } catch (e) {
                console.error('Invalid URL');
                return;
            }

            // Wyciągamy ID filmu z URL
            const urlParams = new URLSearchParams(new URL(videoUrl).search);
            const videoId = urlParams.get('v');
            if (!videoId) {
                console.error('Invalid YouTube link');
                return;
            }

            // Tworzymy iframe z filmem YouTube
            const iframe = document.createElement('iframe');
            iframe.setAttribute('width', '560');
            iframe.setAttribute('height', '315');
            iframe.setAttribute('src', 'https://www.youtube.com/embed/' + videoId + '?autoplay=1');
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
            iframe.setAttribute('allowfullscreen', true);

            // Znajdujemy kontener na wideo
            const videoContainer = element.querySelector('.opinions__wrapper-right-video-video');

            // Usuwamy wszystko z video-container i wstawiamy iframe
            videoContainer.innerHTML = ''; // Czyścimy kontener na wideo
            videoContainer.appendChild(iframe); // Dodajemy iframe z wideo
        });
    });

}

export default Embed;